export default __webpack_public_path__ + "static/media/Kuwait_Airways.72f39500.png";